"use client"

import LeftOpenTicket from './LeftOpenTicket'
import RightOpenTicket from './RightOpenTicket'
import Ticket from '../../dto/ticketDtos'
import Spacer from '../AllPurpose/Spacer'
import { useEffect, useRef, useState } from 'react'
import { useGlobalContext } from '../../context/GlobalContextProvider'
import {
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerDescription,
    DrawerFooter,
    DrawerHeader,
    DrawerTitle,
    DrawerTrigger,
    NoBarDrawerContent
} from "@/components/ui/drawer"
import ExpandedTicket from './ExpandedTicket'
import { ArrowLeft, Camera, Check, Plus, ReceiptText, ShoppingCart, TicketMinus, Tickets, Undo2 } from 'lucide-react'
import { callLogUserEvent } from '@/app/_requests/userCalls'
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
} from "@/components/ui/alert-dialog"

const OpenTicket = ({
    userID,
    ticket,
    isMobile
}) => {

    // window.innerWidth/screen aren't available during SSR; reading them in
    // render yields a different scale on the server vs client and breaks
    // hydration (#418). Default to 1, then measure after mount.
    const [scale, setScale] = useState(1)

    const [hydrated, setHydrated] = useState(false);
    useEffect(() => {
        setHydrated(true);
        if (isMobile && typeof window !== 'undefined') {
            setScale(Math.min(window.innerWidth, screen.width) / 428 * 0.865);
        }
    }, [isMobile]);

    const { allTicketsExpanded, setAllTicketsExpanded, cartTickets, setCartTickets } = useGlobalContext()

    // Pinch-zoom is already blocked by the viewport meta tag in app/layout.jsx
    // (`maximum-scale=1`, `user-scalable=no`). A non-passive touchstart listener
    // at document scope forces the browser to wait for JS before every touch/scroll
    // — a major INP/scroll-jank hit. Listener kept as a no-op passive touch for
    // parity with the previous mount/unmount lifecycle.
    useEffect(() => {
        const noop = () => {};
        document.addEventListener("touchstart", noop, { passive: true });
        return () => {
            document.removeEventListener("touchstart", noop);
        };
    }, []);

    const [addedToCart, setAddedToCart] = useState(false)

    const [ticketDetailsDrawerOpen, setTicketDetailsDrawerOpen] = useState(false)

    const changeCartStatus = () => {

        // checks for null
        // (ensure it's an array)
        const safeCartTickets = Array.isArray(cartTickets) ? cartTickets : [];

        if (addedToCart) {
            // added to cart, so we remove below
            setCartTickets(safeCartTickets.filter(cartTicket => cartTicket.id !== ticket.id));
        } else {
            // not added to cart, so we add below
            // update the global context
            setCartTickets([...safeCartTickets, ticket])
        }

        console.log(`changeCartStatus(), cartTickets:`, cartTickets)

        // changes state for UI
        setAddedToCart(!addedToCart)
    };

    // for % of due bar filled
    const calculateDueBarValue = () => {

        // e.g
        // 100
        let issueDate = ticket.unixIssueDate
        // 300
        let dueDate = ticket.unixDueDate
        // 200
        let denominator = dueDate - issueDate

        // time, in s, since unix in 1970
        let now = Date.now() / 1000

        let numerator = now - issueDate

        let fraction = numerator / denominator

        // prevents dueBarValue > 1
        let value = fraction < 1 ? fraction : 1
        return value

    }

    function daysUntil(unixTimestamp) {
        const now = Date.now(); // current time in ms
        const future = unixTimestamp * 1000; // convert seconds to ms
        const diffInMs = future - now;
        const days = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
        return days;
    }

    function is100DaysAgo() {
        const now = Date.now(); // current time in milliseconds
        const inputTime = ticket.unixIssueDate * 1000; // convert to ms
        const days100Ago = now - (100 * 24 * 60 * 60 * 1000); // 100 days in ms

        return inputTime <= days100Ago;
    }

    const [dueBarValue, setDueBarValue] = useState(calculateDueBarValue())


    // for due date e.g.


    return (
        <div
            className={``}
            style={{
                transform: `scale(${scale})`,
                paddingBottom: isMobile ? 10 * scale : 40
            }}
        >

            {/* base layer */}
            <div
                className={`w-[450px] relative rounded-[12px] bg-white flex flex-row justify-between items-center overflow-hidden pl-[20px] pr-[12.5px] space-x-[7.5px] shadow-md ${addedToCart ? '' : 'active:scale-95'}`}
                style={{
                    borderWidth: 3,
                    // borderColor: (dueBarValue >= 1 ? '#ef4444' : '#d1d5db'),
                    borderColor: addedToCart ? '#1f2937' : '#d1d5db',
                    height: 95,
                    transition: '0.2s ease-in-out'
                }}
            >

                <button
                    className="min-w-[287.5px] flex flex-row h-full relative right-[5px] items-center justify-center"
                >

                    <div className={`min-w-[287.5px] bg-clear`}>
                        {hydrated && (
                            <LeftOpenTicket
                                ticket={ticket}
                                directState=""
                                directPlate=""
                                showDetailsDrawer={() => {
                                    if (
                                        ticket.ticket !== '7348923013' &&
                                        ticket.ticket !== '8343482320'
                                    ) {
                                        setTicketDetailsDrawerOpen(true);

                                        callLogUserEvent({
                                            userID,
                                            context: 'Ticket Scroll',
                                            decisionName: 'Tapped info on a Ticket',
                                            decisionDescription: 'used the icon in the bottom left',
                                            isMajorDecision: false,
                                            metadata: {
                                                ticketNumber: ticket.id,
                                            },
                                        });
                                    }
                                }}
                            />
                        )}

                    </div>
                </button>

                <div className='flex flex-col items-end justify-end h-full'>

                    {is100DaysAgo() == true && (

                        <p className={`text-[18px] font-tpBold text-white bg-red-600 rounded-[6px] flex items-center justify-center p-[7.5px] truncate relative top-[12.5px]`}>
                            TOW RISK
                        </p>
                    )}

                    {(dueBarValue >= 1 && is100DaysAgo() === false) && (
                        <p className={`text-[18px] font-tpBold text-red-700 bg-[#fcd2d2] rounded-[6px] flex items-center justify-center p-[7.5px] truncate relative top-[12.5px]`}>
                            LATE
                        </p>
                    )}

                    {dueBarValue < 1 && (
                        <p className={`text-[18px] font-tpBold text-gray-800 bg-blue-200 rounded-[6px] flex items-center justify-center p-[7.5px] truncate relative top-[12.5px]`}>
                            Due in {daysUntil(ticket.unixDueDate)}d
                        </p>
                    )}

                    <RightOpenTicket
                        userID={userID}
                        ticket={ticket}
                        addedToCart={addedToCart}
                        setAddedToCart={setAddedToCart}
                    />

                </div>

            </div>

            <AlertDialog
                open={ticketDetailsDrawerOpen}
                onOpenChange={setTicketDetailsDrawerOpen}
            >

                <AlertDialogContent
                    className="bg-white p-[15px] rounded-[15px] border-gray-400 border-[1px]"
                    style={{
                        width: isMobile ? '95%' : 400
                    }}
                >

                    <ExpandedTicket
                        ticket={ticket}
                        dismissDrawer={() => {
                            setTicketDetailsDrawerOpen(false)
                        }}
                    />

                    {/* add to cart button */}
                    <div className='w-full h-[60px] flex flex-row items-center justify-center space-x-[15px]'>

                        <button
                            className={`h-[60px] bg-gray-800 rounded-[10px] active:opacity-50 flex flex-1 flex-row justify-center items-center px-[20px]`}
                            style={{
                                backgroundColor: addedToCart ? '#327ff5' : '#327ff5',
                            }}
                            onClick={changeCartStatus}
                        >

                            <div className='w-[24px]' />

                            <Spacer />

                            <h1
                                className={`font-tpBold text-[20px] justify-center text-white truncate`}>
                                {addedToCart ? 'Selected' : 'Select'}
                            </h1>

                            <Spacer />

                            {!addedToCart && (
                                <div className='w-[24px]' />
                            )}

                            {addedToCart && (
                                <Check
                                    size={24}
                                    color={'#ffffff'}
                                    strokeWidth={4}
                                    className='relative'
                                />
                            )}

                        </button>
                    </div>
                </AlertDialogContent>
            </AlertDialog>

        </div >
    )
}

export default OpenTicket
